import React from 'react';

/**
 * @todo: We're dropping this for now. We'll be reimplementing it according to the new
 * How Others Answered designs soon.
 */
export default class TwoWayQuestionResponseStats extends React.Component {
  render() {
    return null;
  }
}
